import * as appMarketService from '../utils/appMarketService';
import { V2App } from '@wix/ambassador-app-service-webapp/http';
import { DocumentServicesObject } from '@wix/document-services-types';

const APP_DEF_ID_QUERY = 'flowAppDefId';
const APP_PARAMS_QUERY = 'flowAppParams';

function getParameterByName(name: string) {
  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get(name);
  return paramValue;
}

const getEditorScriptUrl = (appInfo: V2App): string | undefined => {
  const components = appInfo?.components?.components;
  if (components && Array.isArray(components)) {
    const compData = components.find((comp) => comp?.compType === 'PLATFORM');
    return compData?.compData?.platformComponentData?.editorScriptUrl;
  }
  return undefined;
};

const parseFlowAppParams = (flowAppParamsJSON: string): object => {
  let flowAppParams = {};
  try {
    flowAppParams = JSON.parse(flowAppParamsJSON);
  } catch (originalError) {
    try {
      // support also url-encoded json param
      flowAppParams = JSON.parse(decodeURIComponent(flowAppParamsJSON));
    } catch (e) {
      console.error(
        'Failed to parse flowAppParams. expected a JSON format.',
        originalError,
      );
    }
  }
  return flowAppParams;
};

function runFlowPlatformApps(documentServices: DocumentServicesObject) {
  const flowAppDefId = getParameterByName(APP_DEF_ID_QUERY);

  if (!flowAppDefId) {
    return;
  }

  const flowAppParamsJSON = getParameterByName(APP_PARAMS_QUERY);

  let flowAppParams = {};
  if (flowAppParamsJSON) {
    flowAppParams = parseFlowAppParams(flowAppParamsJSON);
  }

  appMarketService.fetchAppInfo(flowAppDefId).then((appInfo) => {
    if (!appInfo) {
      return;
    }

    const editorScriptUrl = getEditorScriptUrl(appInfo);

    if (!editorScriptUrl) {
      return;
    }

    documentServices.platform.initApp(
      {
        appDefinitionId: flowAppDefId,
        appFields: {
          platform: {
            baseUrls: {},
            editorScriptUrl,
          },
        },
      },
      flowAppParams,
    );
  });
}

export { runFlowPlatformApps };
